import React from 'react';
import { FiMenu, FiX } from 'react-icons/fi';
import './Navbar.css';

const Navbar = ({ mobileMenu, setMobileMenu }) => {
  return (
    <nav className="navbar">
      <div className="container navbar-inner">
        <a href="#home" className="logo">
          <span className="logo-icon">S</span>
          <span className="logo-text">Slink</span>
        </a>
        <ul className={`nav-links ${mobileMenu ? 'active' : ''}`}>
          <li><a href="#home" onClick={() => setMobileMenu(false)}>Home</a></li>
          <li><a href="#features" onClick={() => setMobileMenu(false)}>Features</a></li>
          <li><a href="#earn" onClick={() => setMobileMenu(false)}>Earn Money</a></li>
          <li><a href="#about" onClick={() => setMobileMenu(false)}>About</a></li>
          <li><a href="#contact" onClick={() => setMobileMenu(false)}>Contact</a></li>
        </ul>
        <a href="https://slink.astergo.in/slink-dating-app.apk" className="nav-cta">Download App</a>
        <button className="menu-toggle" onClick={() => setMobileMenu(!mobileMenu)}>
          {mobileMenu ? <FiX size={24} /> : <FiMenu size={24} />}
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
